export default "\n\n.center-text-align {\n  text-align: center;\n}\n";